<template>
  <v-time-picker
    :color="color"
    class="position"
    :value="clockValue"
    :allowed-minutes="allowedMinutes"
    v-on:input="handleChange"
    width='200'
    format="24hr">
  </v-time-picker>
</template>


<script>
import { TimeStampHelper } from '../../util/TimeStamp'

export default {

  props: ['sharedTimeStamp', 'color'],

  methods: {
    /**
     * Make updated timestamp available
     */
    handleChange (newTime) {
      var split = newTime.split(':');

      var hours = split[0];
      var minutes = split[1];

      this.sharedTimeStamp.setUTCHours(hours);
      this.sharedTimeStamp.setUTCMinutes(minutes);

      this.$emit('clockHasChanged', this.sharedTimeStamp);
    },
    /**
     * Only allow 5 minutes intervals
     */
    // allowedMinutes: m => m % 5 === 0
    allowedMinutes: m => true
  },

  computed: {
    /**
     * the current time as string e.g. "11:44"
     */
    clockValue () {
      var isoString = this.sharedTimeStamp.toISOString()
      return TimeStampHelper.extractHoursAndMinutes(isoString);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.position{
  position:absolute;
  top: 475px;
  left: 16px;
  z-index:3;
}

</style>



// WEBPACK FOOTER //
// app/components/timepicker/TimePicker.vue